import { Module } from 'vuex';
import { actions } from '@/dealroom/content-link/store/content-link.actions';
import { mutations } from '@/dealroom/content-link/store/content-link.mutations';
import { IContentLinkBlock } from '@/dealroom/content-link/types/content-link';
import { RootState } from '@/store/store';

export const namespace: string = 'contentLink';

export interface IContentLinkBlockState {
  loading: boolean;
  loaded: boolean;
  validUrl: boolean;
  message: string;
  preview: IContentLinkBlock;
}

export const state: IContentLinkBlockState = {
  loading: false,
  loaded: false,
  validUrl: undefined,
  message: undefined,
  preview: {
    id: '',
    title: '',
    description: '',
    url: '',
    buttonText: '',
    thumbUrl: '',
    thumbExtension: '',
    user: null,
  },
};

export const contentLink: Module<IContentLinkBlockState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};
